import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=bb733ca2&"
import script from "./HowWorks.vue?vue&type=script&lang=js&"
export * from "./HowWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports